import React from "react";

import useStyles from "@hooks/useStyles";

import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";

import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import LineBreak from "@components/Global/Custom/Icons/LineBreak";

const WebsiteEmbedCode = () => {
	const classes = useStyles("Website");

	const backgroundColor = ""; // #ffebe5
	const backgroundGradient = ``; // for testing  linear-gradient(121.04deg,#79dfff 15.69%,#865cff)
	const backgroundImage = ``; // for testing https://wallpapercave.com/wp/wp8377155.jpg
	const coloredBox = false;

	const header = `Website Embed Code`;
	const subHeader = `Put your embed code here`;
	const tagline = "aok";
	const textAlign = "center"; // left / center / right
	const lineBreak = true;
	const content = "";

	const button = "Learn more";
	const buttonLink = "/wesbite/about-us";

	const buttonSecondary = "Secondary";
	const buttonSecondaryLink = "/wesbite/about-us";

	return (
		<React.Fragment>
			<section
				className={
					tagline || header || subHeader || lineBreak || content
						? "websiteComponent"
						: "websiteComponent thin"
				}
				style={{
					backgroundColor:
						!coloredBox && backgroundColor ? backgroundColor : "unset",
					backgroundImage:
						!coloredBox && backgroundGradient ? backgroundGradient : "unset",
				}}
			>
				{backgroundImage && (
					<Box
						position={"absolute"}
						top={0}
						bottom={0}
						width={"100%"}
						style={{
							backgroundImage: `url(${backgroundImage})`,
							backgroundRepeat: "no-repeat",
							backgroundSize: "cover",
							backgroundPosition: "50% 50%",
							opacity: "0.4",
							//filter: "blur(2px)",
						}}
						zIndex={1}
					/>
				)}

				<Container maxWidth={"lg"} disableGutters style={{ zIndex: 3 }}>
					<div
						className={coloredBox ? classes.featuredTextBox : undefined}
						style={{
							backgroundColor:
								coloredBox && backgroundColor ? backgroundColor : "",
							backgroundImage:
								coloredBox && backgroundGradient ? backgroundGradient : "unset",
						}}
					>
						<Grid
							container
							spacing={8}
							justifyContent="center"
							alignItems={textAlign}
						>
							<Grid item xs={12}>
								<Box
									display={"flex"}
									flexDirection={"column"}
									justifyContent={"center"}
									alignItems={textAlign}
									height={"100%"}
								>
									{tagline && (
										<Box className="tagline" textAlign={textAlign}>
											{tagline}
										</Box>
									)}

									{header && (
										<Box component={"h2"} textAlign={textAlign}>
											{header}
										</Box>
									)}

									{subHeader && (
										<Box component={"h3"} textAlign={textAlign}>
											{subHeader}
										</Box>
									)}

									{lineBreak && (
										<Box my={1} textAlign={textAlign}>
											<LineBreak className={classes.lineBreak} />
										</Box>
									)}

									{content && (
										<>
											<Box component={"p"} textAlign={textAlign}>
												{content}
											</Box>
										</>
									)}

									<Box my={6}>{`WHERE THE <> LIVES`}</Box>

									{(button || buttonSecondary) && (
										<Box
											mt={"60px !important"}
											className={classes.columnButtonsBox}
											textAlign={textAlign}
											justifyContent={textAlign}
											width={"100%"}
										>
											{button && (
												<Button
													size="large"
													color="primary"
													variant="contained"
													disableElevation
													href={buttonLink}
													className="columnButton"
												>
													{button}
												</Button>
											)}

											{buttonSecondary && (
												<Button
													size="large"
													color="secondary"
													variant="outlined"
													disableElevation
													href={buttonSecondaryLink}
													className="columnButton"
												>
													{buttonSecondary}
												</Button>
											)}
										</Box>
									)}
								</Box>
							</Grid>
						</Grid>
					</div>
				</Container>
			</section>
		</React.Fragment>
	);
};

export default WebsiteEmbedCode;
